import React from "react";
import "./TextFile.css";

const fileContents = {
  "qui suis je??.txt": `Qui suis-je ?

Je suis Karel Berréhouc, technicien son passionné par la création musicale et l'audiovisuel.

Mon parcours :
- BTS Audiovisuel (2022-2024)
- Ingénieur son en alternance chez SoLobby (2022-2024)
- Mixage, mastering, sonorisation d'événements
- Montage vidéo et animation

Compétences techniques :
- Pro Tools, FL Studio
- Mixage et mastering
- Sonorisation live
- Montage vidéo

Ce qui me passionne :
La création musicale, le basketball, les voyages et l'informatique.

Actuellement en recherche d'opportunités en intermittence, CDD ou CDI.

Contact : k.berrehouc@icloud.com
Téléphone : 07 83 71 35 66`,
  
  "logo_final2.png": "Image : logo_final2.png\n\nAperçu de l'image non disponible dans cette version."
};

export default function TextFile({ onClose, fileName }) {
  const content = fileContents[fileName] || `Contenu de ${fileName}`;

  return (
    <div className="textfile-overlay" onClick={onClose}>
      <div className="textfile-window" onClick={(e) => e.stopPropagation()}>
        <div className="textfile-topbar">
          <div className="textfile-buttons">
            <span className="close" onClick={onClose}></span>
            <span className="minimize"></span>
            <span className="maximize"></span>
          </div>
          <span className="textfile-title">{fileName}</span>
        </div>
        <div className="textfile-content">
          <pre>{content}</pre>
        </div>
      </div>
    </div>
  );
}
